export const CREATE_EMPLOYEE_SUCCESS = 'CREATE_EMPLOYEE_SUCCESS';

export const createEmployeeSuccess = ({ employee }) => ({
    type: CREATE_EMPLOYEE_SUCCESS,
    payload: {
        employee,
    }
});
